//统一管理api
import { base_puti } from "./base"; // 导入接口域名列表
import { get } from "./tool"; // 导入http中创建的axios实例

export const appDownload = (params) => get(base_puti + "/puti/download", params);
export default {
    appDownload,
};
